<pf-content>
    @for (group of groups(); track group.label) {
        <section class="staging-group" pfSection [pfTitle]="group.label">
            @for (item of group.items; track trackByItem($index, item)) {
                <div
                    class="staging-equipment-item"
                    [class.assigned]="item.assigned">
                    <span class="staging-equipment-name">{{
                        item.displayName
                    }}</span>
                    @if (item.assigned) {
                        <pf-connected-chips
                            [chips]="item.locationDisplay"></pf-connected-chips>
                    } @else {
                        <span class="staging-pending">Pending</span>
                    }
                </div>
            }
        </section>
    }

    @if (nextUnassigned()) {
        <cpw-scan-input
            #scanInput
            [autoFocus]="true"
            [inputStyle]="'stacked'"
            [label]="scanLabel()"
            [barcodeSearchFacade]="activeScanFacade()"
            [defaultScanError]="defaultScanError()"
            (barcodeScanned)="onBarcodeScanned($event)"></cpw-scan-input>

        @if (firstGroupAssignment(); as first) {
            <pf-button buttonType="submit" block (click)="applyToAll()">
                Use same location for remaining {{ first.remaining }} equipment
            </pf-button>
        }
    }

    <div id="action-buttons">
        <pf-button buttonType="cancel" block (click)="drawerRef.close()">
            Cancel
        </pf-button>
        <pf-button
            buttonType="submit"
            block
            [disabled]="!allAssigned() || confirmInFlight()"
            (click)="confirmStaging()">
            Confirm
        </pf-button>
    </div>
</pf-content>
